import { useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { Auth0LoginButton, buildAuth0PopupUrl, useAuth } from 'grabbitbot-legacy-ui'
import { AUTH0_LOGIN_EXPECTED_ORIGIN, AUTH0_LOGIN_URL, POST_LOGIN_PATH } from '../../config'

// Equivalent of legacy `LoginComponent`/`UserLoginComponent` (audit §3/§5).
// Owner decision 2026-09-26 (legacy-migration/RULES.md, mirrored from
// simple.cryptopairscreener.com): password-based login and the direct-Google
// popup (audit §10 defect 1 — unvalidated postMessage origin, SECURITY-HIGH)
// both moved to Auth0's Universal Login. This page is just the entry point
// into that flow, via the SAME popup+postMessage handoff — origin-checked
// inside `Auth0LoginButton` itself, nothing page-specific to fix here.
//
// This is also the route-guard fix for audit §3/§10 defect 2 (no route
// guards anywhere) combined with defect 6 (no global 401 handling): a
// successful login here is what makes `RequireAuth` (see
// src/routes/AppRoutes.tsx) let a visitor through to any protected route.
export function LoginPage() {
  const navigate = useNavigate()
  const { status } = useAuth()

  // Visiting /login while already signed in (stale tab, or the popup flow's
  // own message racing a manual reload) goes straight to the app instead of
  // showing a "sign in" screen for an already-signed-in user.
  useEffect(() => {
    if (status === 'authenticated') navigate(POST_LOGIN_PATH, { replace: true })
  }, [status, navigate])

  const goToApp = () => navigate(POST_LOGIN_PATH, { replace: true })

  return (
    <div className="portal-card portal-card--auth">
      <h1>Sign in</h1>
      <p>
        <Auth0LoginButton popupUrl={AUTH0_LOGIN_URL} expectedOrigin={AUTH0_LOGIN_EXPECTED_ORIGIN} onSuccess={goToApp}>
          Log in
        </Auth0LoginButton>
      </p>
      <p>
        <Auth0LoginButton
          popupUrl={buildAuth0PopupUrl(AUTH0_LOGIN_URL, { connection: 'google-oauth2' })}
          expectedOrigin={AUTH0_LOGIN_EXPECTED_ORIGIN}
          onSuccess={goToApp}
        >
          Continue with Google
        </Auth0LoginButton>
      </p>
      <p>
        Forgotten your password, or confirming an old e-mail link?{' '}
        <Link to="/password-forgot">See here</Link>.
      </p>
      <p>
        No account yet? <Link to="/register">Register</Link>
      </p>
    </div>
  )
}
